function reactNativeWebViewPostMessage(message) {
	if (window.ReactNativeWebView) {
		window.ReactNativeWebView.postMessage(message);
	}
}
